import { createContext } from 'react';

export default createContext({ bulk: {}, swag: {}, countries: [] });
